import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { AnimationWrapper, DiskInner, DiskMiddle, DiskOuter, RING_ENTER_MS } from './view';

interface Props {
    // Этот ref используем, чтобы отслеживать изменения размеров аватарки (при переключении вьюшек).
    presenterRef: React.RefObject<any>;
    isOn: boolean;
}

/**
 * Пульс-анимация вокруг аватарки участника.
 */
export const PulseAnimation = ({ isOn, presenterRef }: Props) => {
    // На этот ref вешаются классы анимаций.
    const animationWrapperRef = useRef<HTMLDivElement | null>(null);

    useLayoutEffect(function resizeActiveSpeakerAnimation() {
        const presenter = presenterRef?.current;
        const animWrapper = animationWrapperRef.current;
        if (!presenter || !animWrapper) return;

        animWrapper.style.width = `${presenter.offsetWidth}px`;
        animWrapper.style.height = `${presenter.offsetHeight}px`;

        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (!entry) return;
            const { width, height } = entry.contentRect;
            animWrapper.style.width = `${width}px`;
            animWrapper.style.height = `${height}px`;
        });
        observer.observe(presenter);

        return () => observer.disconnect();
    }, []);

    // State machine анимации. Управление идёт через classList — никакого setState,
    // компонент не ререндерится при переключении фаз.
    useEffect(
        function animateActiveSpeaker() {
            const el = animationWrapperRef.current;
            if (!el) return;

            let contractTimer: ReturnType<typeof setTimeout> | undefined;

            const updatePhase = (speaking: boolean) => {
                // Пользователь начал говорить → сразу .active, гасим таймер сжатия.
                if (speaking) {
                    if (contractTimer) clearTimeout(contractTimer);
                    el.classList.remove('contracting');
                    el.classList.add('active');
                    return;
                }

                // Пользователь замолчал, но анимация не в фазе 'active' — ничего не делаем.
                if (!el.classList.contains('active')) return;

                // Замолчал → сразу запускаем сжатие.
                el.classList.remove('active');
                el.classList.add('contracting');
                contractTimer = setTimeout(() => {
                    el.classList.remove('contracting');
                }, RING_ENTER_MS);
            };

            updatePhase(isOn);

            return () => {
                if (contractTimer) clearTimeout(contractTimer);
            };
        },
        [isOn],
    );

    return (
        <AnimationWrapper ref={animationWrapperRef}>
            <DiskOuter />
            <DiskMiddle />
            <DiskInner />
        </AnimationWrapper>
    );
};
